module.exports = "/assets/logo_sg_audition_1_1-edb3a026da08b8af4f4b3f884c3a0f77.png";